import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'

import type {
  MessageItemBase,
  MessageStatusEnum,
  MessageTypeEnum,
  ServiceTypeEnum,
} from 'Types/beEmailMessageApi'
import type { PagedListOf } from 'Types/common'

interface SearchMessagesQsParams {
  pageSize: number
  pageNumber: number
  orderBy: string
  orderDescending: boolean
}

interface SearchMessagesRequest {
  SearchText?: string
  FullText?: boolean

  Tags?: number[]
  ServiceTypes?: ServiceTypeEnum[]
  MessageTypes?: MessageTypeEnum[]
  Status?: MessageStatusEnum

  LastUpdatedDateRanges?: {
    From?: string
    To?: string
  }
}

const endpoints = ((baseURL: string) => {
  return {
    //  Messages
    getMessageLazyDetails: (idMessage: number) =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/lazy`,
    searchMessages: (idList: number, params: SearchMessagesQsParams) =>
      `${baseURL}/api/list/${idList}/messages/search?${
        encodeParams(params) as string
      }`,
  }
})(process.env.BEEMAILMESSAGE_URL as string)

export const beEmailMessageApiGetMessageLazyDetails = async (
  idMessage: number,
): Promise<MessageItemBase | null> => {
  const url = endpoints.getMessageLazyDetails(idMessage)
  return await apiWrapper({
    method: 'get',
    url,
  }).then(({ data }) => data)
}

export const beEmailMessageApiSearchMessages = async (
  idList: number,
  params: SearchMessagesQsParams,
  searchMessageRequest: SearchMessagesRequest,
): Promise<PagedListOf<MessageItemBase>> => {
  const url = endpoints.searchMessages(idList, params)
  return await apiWrapper({
    method: 'post',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(searchMessageRequest),
  }).then(({ data }) => data)
}
